/* eslint-disable object-shorthand */
/* eslint-disable camelcase */
/* eslint-disable import/order */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import {
  Badge,
  Box,
  FormControl,
  Input,
  InputAdornment,
  InputLabel,
  MenuItem,
  NativeSelect,
  Select,
  Typography,
  makeStyles,
} from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useQueryParams } from '../../../../util/utils'
import { usePermissions } from '../../../../hooks/usePermission'
import { fetchAttendanceInit } from '../../../attendance/AttendanceActions'
import { Link, Route } from 'react-router-dom'
import {
  mdiAccountSearch,
  mdiMagnifyExpand,
  mdiMicrosoftExcel,
  mdiNoteEditOutline,
} from '@mdi/js'
import Icon from '@mdi/react'
import BaseFilter from '../../../../components/hooks/BaseFilter'
import filterStylesComponents from '../../../../assets/filterComponentsStyles'
import { fetchLaundries, makeReport } from '../PartnersActions'
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'

const useStyles = makeStyles({
  container: {
    width: '370px',
  },
  form: {
    maxHeight: 'calc(330px + 50px)',
    overflowY: 'auto',
  },
})

export default function Filter(props) {
  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canCreate, canRead } = usePermissions()

  const location = useLocation()
  const history = useHistory()
  const filters = useQueryParams(location.search)
  const filterClasses = filterStylesComponents()

  const dispatch = useDispatch()

  const onSubmit = (data = filters) => {
    const searchParams = new URLSearchParams(data)
    searchParams.set('page', 1)
    history.push(`${location?.pathname}?${searchParams?.toString()}`)
  }

  const handleSubmit = e => {
    e.preventDefault()

    const formData = e.currentTarget
    const data = new FormData(formData)
    const entries = data.entries()
    const values = Object.fromEntries(entries)

    onSubmit({ ...filters, ...values })
  }

  return (
    <BaseFilter>
      <Grid item xs={12}>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          spacing={2}
        >
          <Grid item xs={10} sm={12} md={6}>
            <form style={{ width: '100%' }} onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Input
                    fullWidth
                    name="name"
                    defaultValue={filters?.name}
                    id="standard-adornment-person"
                    placeholder="Pesquise por nome"
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton aria-label="search name" type="submit">
                          <Icon path={mdiMagnifyExpand} size={1} />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Input
                    fullWidth
                    name="email"
                    defaultValue={filters?.email}
                    id="standard-adornment-person"
                    placeholder="Pesquise por email"
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton aria-label="search email" type="submit">
                          <Icon path={mdiMagnifyExpand} size={1} />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>
              </Grid>
            </form>
          </Grid>

          <Grid item xs={12} sm={12} md>
            <Grid
              container
              alignItems="center"
              justifyContent="flex-end"
              spacing={2}
            >
              <Grid item xs={12} className={filterClasses.areaButtons}>
                {canRead('modulo-parceiros', permissionUser) && (
                  <IconButton
                    className={filterClasses.btnAdd}
                    onClick={() => {
                      dispatch(makeReport(filters))
                    }}
                  >
                    <Icon path={mdiMicrosoftExcel} size={1} />
                    Download
                  </IconButton>
                )}
                {canCreate('modulo-parceiros', permissionUser) && (
                  <IconButton
                    component={Link}
                    className={filterClasses.btnAdd}
                    to="/partners-module/partner/new"
                  >
                    <Icon
                      path={mdiNoteEditOutline}
                      size={1}
                      style={{ marginRight: '4px' }}
                    />
                    Cadastrar
                  </IconButton>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </BaseFilter>
  )
}
